<template>
    <aside class="AdminNavbar">
        <div
            class="Collapser"
            :class="{ 'active-menu' : !collapsed }"
        >
            <span
                class="MenuIcon"
                @click="$emit('toggleCollapse')"
            >
                <span />
            </span>
            <div
                class="Brand"
            >
                <RouterLink
                    :to="{ name: 'Main' }"
                    class="Logo"
                >
                    <img
                        v-if="logo"
                        :src="logo"
                        :alt="label"
                    >
                    <WText
                        v-if="!logo"
                        tag="h1"
                        hidden
                    >
                        {{ label }}
                    </WText>
                </RouterLink>
            </div>
        </div>
        <ul :class="{ horizontal }">
            <NavItems
                v-for="(navItem, index) in navbar"
                :key="`navLink-${index}`"
                :collapsed="collapsed"
                v-bind="navItem"
            />
        </ul>
        <div
            class="Footer"
            :class="{ collapsed }"
        >
            <a
                href="#"
                class="flex row-left-center"
                @click.prevent="$emit('onSignout')"
            >
                <WIcon
                    icon="exit"
                    color="accent-blue"
                    :size="20"
                />
                <Transition
                    name="fade"
                    mode="out-in"
                >
                    <WText
                        v-if="!collapsed"
                        tag="span"
                        weight="semi"
                        color="accent-blue"
                        :size="14"
                    >
                        {{ $t('auth.signout.title') }}
                    </WText>
                </Transition>
            </a>
        </div>
    </aside>
</template>

<script>
import VueTypes from 'vue-types'
import { NavItems } from '@/components'

export default {
    name: 'AdminNavbar',
    components: {
        NavItems,
    },
    props: {
        navbar: VueTypes.arrayOf(VueTypes.shape({
            to: VueTypes.shape({
                name: VueTypes.string,
            }).loose,
            label: VueTypes.string,
            icon: VueTypes.string,
            attrs: VueTypes.shape({
                hidden: VueTypes.bool,
            }).loose,
        }).loose),
        logo: VueTypes.string,
        label: VueTypes.string,
        horizontal: VueTypes.bool.def(false),
        collapsed: VueTypes.bool.def(true),
    },
}
</script>

<style scoped lang="scss">
$width: 200px;
$icon-width: 22px;

.AdminNavbar {
    position: relative;
    background-color: $navbar-bg;
    flex: 1;
    width: $width;
    overflow-y: scroll;
    z-index: $zindex-navbar + 1;

    .Brand {
        transition: opacity .3s ease-out;
        position: absolute;
        left: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        overflow: hidden;
        height: $navbar-height;
        padding: 12px 0;
        box-sizing: border-box;
        opacity: 0;
        pointer-events: none;
    }

    .Logo {
        display: flex;
        width: 100px;
        img {
            width: 100%;
        }
    }

    ul {
        margin: 0;
        padding: 0;
        width: 100%;
        list-style: none;
    }

    &.horizontal {
        display: flex;

        .Link {
            color: $white;

            .WText, .WIcon {
                color: $white;
            }
        }
    }
}

.Collapser {
    position: sticky;
    top: 0;
    padding: 0 15px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    height: $navbar-height;
    border-bottom: solid 1px rgba($primary, .1);
    box-sizing: border-box;
    z-index: 1;

    .WIcon {
        transition: background-color .3s ease-out transform .3s ease-out;
        cursor: pointer;
        padding: 13px;
        display: inline-block;
        width: $menu-bar-width;
        text-align: center;
        box-sizing: border-box;
    }

    &.active-menu .Brand {
        opacity: 1;
        pointer-events: auto;
    }
}

.MenuIcon {
    position: relative;
    display: inline-block;
    padding: 6px 4px;
	width: $icon-width;
    height: 16px;
    cursor: pointer;

    span {
        transition: background-color 0.3s;
        position: relative;
        top: 50%;
        display: block;
        width: 100%;
        height: 2px;
        margin-top: -1px;
        border-radius: 3px;
        background-color: $primary;
        user-select: none;

        &:after, &:before {
            content: '';
            transition: transform 0.3s;
            position: absolute;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 3px;
            background-color: $primary;
        }
        &:after {
            transform: translateY($icon-width/3);
        }
        &:before {
            transform: translateY(-$icon-width/3);
        }
    }
    .active-menu & span {
        &:after {
            transform: translateY($icon-width/6) translateX(-$icon-width/3.5) rotate(45deg) scaleX(0.55);
        }
        &:before {
            transform: translateY(-$icon-width/6) translateX(-$icon-width/3.5) rotate(-45deg) scaleX(0.55);
        }
    }
}

.Footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    max-width: $width;
    border-top: solid 1px rgba($primary, .1);
    overflow: hidden;
    transition: all 350ms ease;

    &.collapsed {
        max-width: $menu-bar-width;
    }

    a {
        min-height: 44px;
        padding: 4px 15px;
        font-size: 14px;
        transition: all 350ms ease;

        &:hover {
            background-color: rgba($accent-blue, .1);
        }

        .WIcon {
            margin: 0 15px 0 5px;
        }

        .WText {
            white-space: nowrap;
        }
    }
}
</style>
